<template>
  <section class="calendly-section">
    <div class="columns calendly-columns">
      <div class="column is-3 is-hidden-mobile" @click="close"></div>
      <div class="column is-12-mobile is-9-tablet calendly-holder">
        <a class="close-link" @click="close">
          <img src="@/assets/close.svg" />
        </a>

        <div class="calendly-inline-widget" :data-url="`https://calendly.com/platforme-mto??hide_landing_page_details=1?hide_landing_page_details=1&name=${form.name}&email=${form.email}`"></div>
      </div>
    </div>
  </section>
</template>

<script>
  export default {
    name: 'Schedule',
    props: {
      form: Object
    },
    mounted() {
      let calendlyScript = document.createElement('script')
      calendlyScript.setAttribute('src', 'https://assets.calendly.com/assets/external/widget.js')
      document.head.appendChild(calendlyScript)

      this.emitValidate()
    },
    created() {
      window.addEventListener('message', this.messageEvent);
    },
    destroyed() {
      window.removeEventListener('message', this.messageEvent);
    },
    methods: {
      validate() {
        return true
      },
      emitValidate() {
        this.$emit('validated', this.validate())
      },
      close() {
        this.$emit('back')
      },
      messageEvent(e) {
        if(e.data.event && e.data.event.indexOf('calendly') === 0) {
          if (e.data.event == "calendly.event_scheduled") {
            const uri = e.data.payload.event.uri
            const index = uri.lastIndexOf("/")

            this.form.calendlyId = uri.substr(index).substr(1)
            this.$emit('scheduled')
          }
        }
      }
    }
  }
</script>

<style lang="scss" scoped>
  .calendly-section {
    position: fixed;
    top: 0px;
    right: 0;
    width: 100%;
    height: 100vh;
    z-index: 1000;
  }

  .calendly-columns {
    height: 100vh;
    margin-top: 0;
    margin-bottom: 0;
  }

  .calendly-holder {
    background: #fff;
    z-index: 100;
    height: 100vh;
  }

  .close-link {
    float: right;
    margin-right: 20px;
    margin-top: 10px;
    padding-bottom: 10px;
  }

  .calendly-inline-widget {
    min-width: 100%;
    height: calc(100% - 45px);
    clear: both;
  }
</style>
